<template>
    <validation-observer ref="validationObserver" v-slot="{ meta }" :initial-values="brandingData">
        <page :tabs="tabs" :busy="busy">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <form-checkbox v-model="brandingData.apply_to_documents">
                            Enable branding for all pdf documents.
                        </form-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3">
                        <validation-provider
                            name="document_margins.top"
                            rules="required|pixelValue"
                            v-slot="{ errors, handleChange }"
                        >
                            <form-input
                                v-model="brandingData.document_margins.top"
                                floatingLabel="Margin Top"
                                :error="errors[0]"
                                @input="handleChange"
                            ></form-input>
                        </validation-provider>
                    </b-col>
                    <b-col md="3">
                        <validation-provider
                            name="document_margins.bottom"
                            rules="required|pixelValue"
                            v-slot="{ errors, handleChange }"
                        >
                            <form-input
                                v-model="brandingData.document_margins.bottom"
                                floatingLabel="Margin Bottom"
                                :error="errors[0]"
                                @input="handleChange"
                            ></form-input>
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <span>Header</span>
                        <form-ckeditor-v2
                            @ready="(editor) => onReadyComponent(editor, 'header')"
                            v-model="brandingData.header.html"
                            id="header_branding"
                            :config="{ hideImageUpload: true }"
                        ></form-ckeditor-v2>
                        <Teleport v-if="brandingData.header.editor" to="#header_branding .ck-toolbar__items">
                            <span
                                role="toolbar"
                                aria-labelledby="cke_430_label"
                                class="ck d-block w-100 ck-reset_all-excluded"
                                id="cke_430"
                            >
                                <div class="w-50 search-field" @click="focusInput('header')">
                                    <form-search-field
                                        class="w-100 mb-0"
                                        ref="search_field_header"
                                        :options="brandingData.header.tagsOptions"
                                        @input="(val) => onSearchTag(val, 'header')"
                                        :busy="busy"
                                        :value="brandingData.header.search"
                                        @select="(val, text) => selectTag(val, text, 'header')"
                                        :rightButton="rightButtonConfig"
                                        :rightButton2="rightButtonConfig2"
                                        placeholder="Search Tag"
                                        @right-button-click="onRightButtonClick('header')"
                                        @right-button2-click="insertHtmlTag('header')"
                                        :isGrouped="true"
                                    />
                                </div>
                            </span>
                        </Teleport>
                    </b-col>
                    <b-col>
                        <span>Footer</span>
                        <form-ckeditor-v2
                            @ready="(editor) => onReadyComponent(editor, 'footer')"
                            v-model="brandingData.footer.html"
                            id="footer_branding"
                            :config="{ hideImageUpload: true }"
                        ></form-ckeditor-v2>
                        <Teleport v-if="brandingData.footer.editor" to="#footer_branding .ck-toolbar__items">
                            <span
                                role="toolbar"
                                aria-labelledby="cke_430_label"
                                class="ck d-block w-100 ck-reset_all-excluded"
                                id="cke_430"
                            >
                                <div class="w-50 search-field" @click="focusInput('footer')">
                                    <form-search-field
                                        class="w-100 mb-0"
                                        ref="search_field_footer"
                                        :options="brandingData.footer.tagsOptions"
                                        @input="(val) => onSearchTag(val, 'footer')"
                                        :busy="busy"
                                        :value="brandingData.footer.search"
                                        @select="(val, text) => selectTag(val, text, 'footer')"
                                        :rightButton="rightButtonConfig"
                                        :rightButton2="rightButtonConfig2"
                                        placeholder="Search Tag"
                                        @right-button-click="onRightButtonClick('footer')"
                                        @right-button2-click="insertHtmlTag('footer')"
                                        :isGrouped="true"
                                    />
                                </div>
                            </span>
                        </Teleport>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div class="d-flex align-items-center">
                            <b-button :disabled="!meta.valid" class="mr-2" @click="save" variant="primary"
                                >Save</b-button
                            >
                            <b-button :disabled="!meta.valid" class="mr-2" @click="preview" variant="default"
                                >Preview</b-button
                            >
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </page>
    </validation-observer>
</template>

<script>
import api from '../../api';
import FormCheckbox from '../generic/form-checkbox/form-checkbox.vue';
import formCkeditorV2 from '../generic/form-ckeditor-v2/form-ckeditor-v2.vue';
import { formatResponseError } from '../../utils/api';
import formSearchField from '../generic/form-search-field/form-search-field.vue';
import formInput from '../generic/form-input/form-input.vue';
import page from '../generic/page/page.vue';
import { DOCUMENT_REPORT_TEMPLATE_VARIABLES_ENDPOINT, TEMPLATE_BRANDING_ENDPOINT } from '../../endpoints';
export default {
    components: {
        page,
        FormCheckbox,
        formCkeditorV2,
        formSearchField,
        formInput,
    },
    data() {
        return {
            busy: false,
            brandingData: {
                id: null,
                apply_to_documents: false,
                document_margins: {
                    top: '60px',
                    bottom: '60px',
                },
                header: {
                    search: '',
                    selectedTag: '',
                    editor: null,
                    tagsOptions: [],
                    html: '',
                },
                footer: {
                    search: '',
                    selectedTag: '',
                    editor: null,
                    tagsOptions: [],
                    html: '',
                },
            },
            tags: [],
            tabs: [
                {
                    title: 'Branding',
                    active: true,
                },
            ],
            rightButtonConfig: {
                icon: ['fas', 'arrow-down'],
                variant: 'default',
            },
            rightButtonConfig2: {
                variant: 'default',
                text: 'Insert Tag',
            },
        };
    },
    computed: {},
    mounted() {
        this.fetchBranding();
        this.fetchTags();
    },
    methods: {
        async fetchBranding() {
            try {
                this.busy = true;
                const { data } = await api.get(TEMPLATE_BRANDING_ENDPOINT());
                this.brandingData.header.html = data.header_html ?? '';
                this.brandingData.footer.html = data.footer_html ?? '';
                this.brandingData.id = data.id;
                this.brandingData.apply_to_documents = data.apply_to_documents;
                if (data.document_margins) {
                    this.brandingData.document_margins = data.document_margins;
                }
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not fetch branding' });
            } finally {
                this.busy = false;
            }
        },
        async fetchTags() {
            try {
                const { data } = await api.get(DOCUMENT_REPORT_TEMPLATE_VARIABLES_ENDPOINT());
                const options = data.map((item) => {
                    return {
                        text: `${item.tag}: ${item.description}`,
                        value: item.tag,
                        group: item.group.toLowerCase(),
                    };
                });
                this.brandingData.header.tagsOptions = options;
                this.brandingData.footer.tagsOptions = options;
                this.tags = data;
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not fetch tags' });
            } finally {
                this.busy = false;
            }
        },
        onReadyComponent(editor, field) {
            this.brandingData[field].editor = editor;
        },
        onRightButtonClick(field) {
            this.brandingData[field].search = '  ';
            if (!this.brandingData[field].search.trim()) {
                this.selectedTag = '';
            }
            const options = this.tags.map((item) => {
                return {
                    text: `${item.tag}: ${item.description}`,
                    value: item.tag,
                    group: item.group.toLowerCase(),
                };
            });
            this.brandingData[field].tagsOptions = options;
        },
        onSearchTag(value, field) {
            if (!value.trim()) {
                this.brandingData[field].selectedTag = '';
            }
            const options = this.tags.map((item) => {
                return {
                    text: `${item.tag}: ${item.description}`,
                    value: item.tag,
                    group: item.group.toLowerCase(),
                };
            });
            const filteredOptions = options.filter((item) => item.text.toLowerCase().indexOf(value.toLowerCase()) > 0);
            if (
                options
                    .map((item) => {
                        return {
                            text: `${item.tag}: ${item.description}`,
                            value: item.tag,
                            group: item.group.toLowerCase(),
                        };
                    })
                    .some((item) => item.text.toLowerCase() !== value.toLowerCase())
            ) {
                this.brandingData[field].selectedTag = '';
            }
            this.brandingData[field].tagsOptions = filteredOptions;
        },
        selectTag(text, value, field) {
            this.brandingData[field].search = text;
            this.brandingData[field].selectedTag = value;
        },
        focusInput(field) {
            const search = this.$refs[`search_field_${field}`];
            if (search.$children[0]) {
                if (search.$children[0].$children[0]) {
                    if (search.$children[0].$children[0].$children[0]) {
                        const inputDiv = search.$children[0].$children[0].$children[0].$el;
                        inputDiv.querySelector('input').focus();
                        inputDiv.querySelector('input').select();
                    }
                }
            }
        },
        insertHtmlTag(field) {
            const selectedTag = this.brandingData[field].selectedTag;
            const editor = this.brandingData[field].editor;
            editor.model.change((writer) => {
                const viewFragment = editor.data.processor.toView(selectedTag);
                const modelFragment = editor.data.toModel(viewFragment);
                editor.model.insertContent(modelFragment, editor.model.document.selection);
            });
        },
        resetFontSize(field) {
            const model = this.brandingData[field].editor.model;
            const doc = model.document;

            model.change((writer) => {
                const range = model.createRange(
                    model.createPositionAt(doc.getRoot(), 0),
                    model.createPositionAt(doc.getRoot(), 'end')
                );
                writer.setSelection(range);
                for (const item of range.getItems()) {
                    if (item.textNode && !item.textNode?._attrs?.get('fontSize')) {
                        writer.setAttribute('fontSize', '14px', item);
                    }
                }
            });
        },
        async save() {
            this.resetFontSize('header');
            this.resetFontSize('footer');
            try {
                this.busy = true;
                const data = {
                    footer_html: this.brandingData.footer.html,
                    header_html: this.brandingData.header.html,
                    apply_to_documents: this.brandingData.apply_to_documents,
                    document_margins: this.brandingData.document_margins,
                };
                let response = null;
                if (!this.brandingData.id) {
                    response = await api.post(TEMPLATE_BRANDING_ENDPOINT(), data);
                } else {
                    response = await api.patch(TEMPLATE_BRANDING_ENDPOINT(this.brandingData.id), data);
                }
                this.brandingData.id = response?.data?.id;
                this.successToast({ text: 'Branding saved successfully.' });
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not save branding.' });
            } finally {
                this.busy = false;
            }
        },
        async preview() {
            try {
                await this.save();
                this.busy = true;
                const { data } = await api.get(`${TEMPLATE_BRANDING_ENDPOINT()}preview/`, {
                    responseType: 'blob',
                });
                saveAs(data, `preview.pdf`);
            } catch (e) {
                this.errorToast({ text: 'Could not preview template. Please double-check your template.' });
            } finally {
                this.busy = false;
            }
        },
    },
};
</script>

<style>
</style>